import keyBy from 'lodash/keyBy';
import { useMemo } from 'react';

import type { InspiredGlobalStudyPlatformApiModelsChart as CumulativeGrades } from 'applications/GSP/shared/api/gsp';
import type { DataPoint } from 'shared/components/charts/BarChart';

export const useCumulativeGrades = (
  data?: CumulativeGrades,
): DataPoint[] | undefined =>
  useMemo(() => {
    if (!data) {
      return undefined;
    }

    const {
      seriesCollection: [{ dataPoints }],
      xAxis,
    } = data;

    const groupedDataPoints = keyBy(
      dataPoints,
      ({ xCoordinate: { label } }) => label,
    );

    return xAxis.map(({ label, value }) => {
      const existedDataPoint = groupedDataPoints[label];

      if (!existedDataPoint) {
        return {
          id: value.toString(),
          x: label,
          y: undefined,
          yLabel: undefined,
        };
      }

      const {
        id,
        xCoordinate: { label: x },
        yCoordinate: { value: y, label: yLabel },
      } = existedDataPoint;

      return { id, x, y, yLabel };
    });
  }, [data]);
